import React from 'react';
import languageFile from '../../../../public/languages/Translation';

export const SubscribedUserPayamentTitle = () => {
	return (
		<div className='page-header '>
			<h1>{languageFile[localStorage.getItem('language')]["24101"]}</h1>
		</div>
	);
};
